// import AdminHomeUI from './AdminHomeUI';
import { connect } from 'react-redux';
import img1 from '../../images/Pic1.png';
import img2 from '../../images/Pic2.jpg';
import img3 from '../../images/Pic3.jpeg';
import img4 from '../../images/Pic4.jpg';
import img5 from '../../images/Pic5.png';
import LinkCard from '../Common/LinkCard';
import { clearStateAction } from '../../redux/actions/admin/AdminAction';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { clearCustomerStateAction } from '../../redux/actions/customer/CustomerAction';

function AdminHome({ clearStateAction, clearCustomerStateAction }){
    useEffect(() => {
        clearStateAction();
        clearCustomerStateAction();
    }, []);
    
    const user = JSON.parse(localStorage.getItem('user'));
    const username = user && user.username;

    return(
        <div className="admin-page">
            <div className='row'>
                <p className='col-md-9 display-5 mb-5 mt-3'>Welcome To The Admin Page!!</p>  
                <small className='col-md-3 mb-5 mt-3'>you have logged in as <i className='h6'>{username}&nbsp;&nbsp;&nbsp;</i><FontAwesomeIcon className='' key={1} icon={faUser} /></small>
            </div>
            <div className="d-flex justify-content-center">
                <div className="row">
                    <LinkCard imgsrc={img1} path="/admin/available-stock" title="View Products In Stock" para="To fetch all the available products in stock" />
                    <LinkCard imgsrc={img2} path="/admin/get-report" title="View Monthly Report" para="To fetch a monthly stock report" />
                    <LinkCard imgsrc={img3} path="/admin/products-by-customer" title="View All Products from Customers" para="To view products related to customers" />
                    <LinkCard imgsrc={img4} path="/admin/supplier-and-products" title="View All Products by Suppliers" para="To view products related to suppliers" />
                    <LinkCard imgsrc={img5} path="/admin/check-stock" title="Check Products In Stock" para="To Check for the product availability in stock" />
                </div>
            </div>
        </div>
    );
}

const mapDispatchToProps = {
    clearStateAction,
    clearCustomerStateAction
};
const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);